<template>
	<div>
		<el-card style="margin: 40px 10px;position: relative;">
			<img src="../assets/memuBj.jpg" class="image">
			<div class="image_title">
				<div class="image_title_title"></div>
				<div class="image_title_box">
					<span>智教荟系列产品之—</span>
					<span>课程管理系统</span>
				</div>
			</div>
			<div class="image_box">
				<span>排课选课系统拥有三种角色：管理员、教师和学生
- 管理员：班级管理、课程管理、创建课程、管理员管理、教师管理、学生管理、选课修改、院系管理、专业管理、设置用户权限
- 教师：成绩录入、课表查看、授课查询
- 学生：查看选修课程、选课、成绩查询、课表查询、个人信息修改</span>
			</div>
		</el-card>
	</div>
</template>

<script>
	// import * as api from "../api/news";

	export default {
		name: "Home",
		data() {
			return {
				tableData: []
			};
		},
		// methods: {
		//   query() {
		//     api.get().then(res => {
		//       this.tableData = res;
		//     });
		//   },
		//   openNews(url) {
		//     window.open(url, "_blank");
		//   }
		// },
		created() {
			this.query();
		}
	};
</script>

<style scoped>
	.home-wrap {
		height: 100%;
		width: 100%;
	}

	.main-wrap {
		margin-top: 10px;
		height: 100%;
		width: 100%;
		background-color: #fff;
		border: 1px solid #ddd;
		border-radius: 5px;
	}

	.home-container {
		height: 100%;
		width: 90%;
		margin: auto;
	}

	.home-aside {
		height: 100%;
	}

	.aside-container {
		width: 90%;
		margin-left: auto;
		margin-right: auto;
		height: 200px;
		margin-top: 20px;
	}

	.aside-img {
		width: 100%;
	}

	.aside-title {
		color: #333;
		font-size: 18px;
	}

	.aside-content {
		font-size: 12px;
		color: #999;
	}

	.image {
		width: 100%;
		display: block;
		position: relative;
	}

	.image_title {
		position: absolute;
		display: flex;
		left: 120px;
		top: 100px;
	}
	
	.image_title_title {
		width: 3px;
		height: 80px;
		background-color: #FFFFFF;
	}
	
	.image_title_box {
	  width: 100%;
	  height: 80px;
	  display: flex;
	  flex-direction: column;
	  justify-content: space-between;
	  margin-left: 10px;
	}
	
	.image_title_box span:nth-child(1) {
	  display: inline-block;
	  font-size: 18px;
	  color: #FFFFFF;
	  letter-spacing: 2pt;
	}
	
	.image_title_box span:nth-child(2) {
	  font-size: 28px;
	  color: #FFFFFF;
	  letter-spacing: 2pt;
	}
	
	.image_box {
	  padding: 20px;
	  font-size: 14px;
	  text-indent:2em;
	  line-height: 30px;
	  word-wrap:break-word
	}
</style>
